import React from 'react';
import { Button } from 'reactstrap';
export const tableColumns = [

    {
        Header: "Task Name",
        id: "taskName",
        accessor: d => <div title={d.taskName}>{d.taskName}</div>
        // <div title={d.counterpartyName}>{d.counterpartyName}</div>
    },
    {
        Header: "Status",
        id: "sectionStatus",
        accessor: "sectionStatus"
    },
    {
        Header: "Comments",
        id: "comments",
        accessor: "comments",
        className: 'center'
    },
    {
        Header: "Actions",
        id: "action",
        accessor: d => 
            <div>
                <Button outline color="info" title="Download Excel" onClick={() => this.parent.handleDownload(d)}>
                    <i className="fa fa-download"></i>
                </Button>
                <Button outline color="info" className="position-relative ml-3" title="Upload Excel" >
                    <input onChange={this.handleUpload} type="file" name="file" id="file" className="upload-file" title="Upload Excel" />
                    <i className="fa fa-upload"></i>
                </Button>
            </div>,
        className: 'center'
    }
]

export const FINANCIAL = 'FINANCIAL';
export const DATA = 'DATA';